import classNames from 'classnames';
import AddButton from './AddButton';
import s from './TableRow.module.scss';

type Props = {
  state?: null | 'success' | 'warning' | 'error' | 'muted' | 'note';
  title?: string;
  className?: string;
} & (
  | {
    rowNumber: number;
    onAdd: (newRowIndex: number) => void;
  }
  | {
    rowNumber?: number;
    onAdd?: never;
  }
);

const TableRow: React.FC<Props> = ({ children, className, rowNumber, title, state = null, onAdd }) => {
  const handleAdd = (): void => {
    if (onAdd) {
      onAdd(rowNumber + 1);
    }
  };
  return (
    <tr title={title} className={classNames(s.wrapper, state === 'success' && s.success, state === 'warning' && s.warning, state === 'error' && s.error, state === 'muted' && s.muted, state === 'note' && s.note, className)}>
      {children}
      {onAdd && <AddButton onClick={handleAdd}></AddButton>}
    </tr>
  );
};

export default TableRow;
